import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, CUSTOMER_FEEDBACK } from './constants';


class CustomerFeedback extends BaseApi {
	getCustomerFeedbackAverage(OrderNo: string) {
		return this.fetch(`CustomerFeedback/GetCustomerFeedbackAverage?orderNo=${OrderNo}`);
	}
}
export const apiProvider = new CustomerFeedback(DMS_MODULE, CUSTOMER_FEEDBACK);
